<template>
	<div class="question-teacher-list-wrap main">
		<div class="title_wrap clearfix">
			<p class="title left">请选择要提问的老师</p>
			<div class="title_change right">
				<p class="change_wrap left yf-text_12 clearfix">
					<nuxt-link to="/question/teacher-list" :class="{ activespan: !$route.query.order }">按回答数量排序</nuxt-link>
          <nuxt-link :to="{ query: {order: 1} }" :class="{ activespan: $route.query.order }">按价格排序</nuxt-link>
				</p>
				<form class="search_wrap left clearfix">
          <input v-if="$route.query.order" type="hidden" name="order" :value="$route.query.order" />
          <button type="submit">搜索</button>
  				<input type="text" placeholder="请输入您要查找老师的名字" name="keyword" :value="$route.query.keyword" />
				</form>
			</div>
		</div>
		<ul class="item_wrap clearfix">
			<li class="item left" v-for="item in list" :key="item.id">
				<section class="img_wrap left">
					<nuxt-link target="_blank" rel="noopener" :to="`/question/list/${item.id}`">
            <img v-lazy="isSupportWebp(item.avatar)" :alt="item.userName" />
          </nuxt-link>
				</section>
				<section class="text_wrap left">
          <div class="text_wrap-a clearfix">
            <p class="left">
              <nuxt-link class="inline ellipsis" target="_blank" :to="`/question/list/${item.id}`">{{ item.userName }}</nuxt-link>
            </p>
					  <p class="right">已回答 <span>{{ item.questionAnswerTotal > 99 ? '99+' : item.questionAnswerTotal }}</span></p>
          </div>
          <div class="text_wrap-b clearfix">
            <p class="left"><span>{{ item.questionPrice }}</span>G币/次</p>
					  <p class="yf-text_12 right btn-ask" @click="handleAsk(item)">提问</p>
          </div>
				</section>
			</li>
		</ul>
    <!--分页-->
    <y-pager :total="total" :num="40"></y-pager>
	</div>
</template>

<script>
import Dialog from '@/utils/Dialog'
import Webp from '@/mixins/Webp'

export default {
  mixins: [Webp],
  name: 'question-teacher-list',
  scrollToTop: true,
  watchQuery: ['page', 'num', 'order', 'keyword'],
  async asyncData ({ params, query, store, $axios }) {
    let apiParams = {
      page: query.page || 1,
      num: query.num || 40,
      order: query.order === undefined ? 'num' : 'gcoins',
      keyword: query.keyword || undefined
    }
    let { list, totalCount } = await $axios._get('/Ask/TeacherList', apiParams)
    return {
      // 过滤掉钱多多
      list: list.filter(_ => _.id !== 54),
      total: totalCount
    }
  },
  head () {
    return {
      title: '问答列表-问答-一富财经—打造中国最靠谱的的投资者教育平台,股市直播,股票交流'
    }
  },
  methods: {
  	handleAsk (type) {
  		if(!this.$isLogin()){
				Dialog.login()
				return
      }
      // 老师身份不能问别人问题
      if (this.$store.getters['user/isTeacher']) {
        Dialog.alert('您是尊贵的老师身份，目前暂时还不支持老师向老师提问哦~~')
        return
      }
      Dialog.ask(type)
  	}
  }
}
</script>
